<div class="ui-filter-select">
  <mat-icon class="ui-filter-select__icon" *ngIf="showIcon">filter_list</mat-icon>
  <select class="ui-filter-select__field" [value]="value" (change)="onChange($event)">
    <option *ngFor="let opt of options" [value]="opt.value">{{ opt.label }}</option>
  </select>
</div>
